import { __assign } from '../../../_virtual/_tslib.js';
import React, { Suspense } from 'react';
import { evaluateHidePostOffering } from '../../../utils/BrandedCommunity/PostOffering/evaluateHidePostOffering.js';

var PostOffering = React.lazy(function () { return import('./PostOffering.js'); });
var LazyLoadedPostOffering = function (props) {
    var showOffering = props.showOffering, offering = props.offering;
    if (evaluateHidePostOffering({ showOffering: showOffering, offering: offering }))
        return null;
    return (React.createElement(Suspense, { fallback: null },
        React.createElement(PostOffering, __assign({}, props))));
};

export { LazyLoadedPostOffering as default };
//# sourceMappingURL=LazyLoadedPostOffering.js.map
